/**
 * Quick Add Sizes - Gestion de l'ajout au panier direct depuis les cartes produits
 */

(function() {
  'use strict';

  // Empecher l'initialisation multiple
  if (window.quickAddSizesInitialized) return;
  window.quickAddSizesInitialized = true;

  // Gestion du bouton trigger (mobile) pour deployer les tailles
  document.addEventListener('click', function(evt) {
    const trigger = evt.target.closest('.quick-add-sizes__trigger');
    if (!trigger) return;

    evt.preventDefault();
    evt.stopPropagation();

    const container = trigger.closest('.quick-add-sizes');
    const isExpanded = container.classList.contains('is-expanded');

    // Fermer les autres quick-add ouverts
    document.querySelectorAll('.quick-add-sizes.is-expanded').forEach(function(el) {
      if (el !== container) {
        el.classList.remove('is-expanded');
        var otherTrigger = el.querySelector('.quick-add-sizes__trigger');
        if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
      }
    });

    // Toggle l'etat
    container.classList.toggle('is-expanded');
    trigger.setAttribute('aria-expanded', String(!isExpanded));
  });

  // Fermer au clic en dehors (avec delai pour eviter conflit)
  document.addEventListener('click', function(evt) {
    // Ne pas fermer si on clique sur un element du quick-add
    if (evt.target.closest('.quick-add-sizes')) return;

    document.querySelectorAll('.quick-add-sizes.is-expanded').forEach(function(el) {
      el.classList.remove('is-expanded');
      var trigger = el.querySelector('.quick-add-sizes__trigger');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  });

  // Gestion de l'ajout au panier
  document.addEventListener('click', async function(evt) {
    const btn = evt.target.closest('.quick-add-sizes__btn');
    if (!btn) return;

    // Ignorer si disabled ou deja en cours de chargement
    if (btn.disabled || btn.classList.contains('quick-add-sizes__btn--loading')) return;

    evt.preventDefault();
    evt.stopPropagation();

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const container = btn.closest('.quick-add-sizes');

    // Ajouter l'etat de chargement
    btn.classList.add('quick-add-sizes__btn--loading');
    btn.disabled = true;

    try {
      // Détection robuste : le tag <cc-cart-cross-sell> a un tag de fermeture
      // mismatch dans le thème (</cross-sell-products>), donc on s'appuie aussi
      // sur le wrapper .cart-item-upsells[data-reco-promo-zone] (fiable).
      const isFromCartDrawerReco = !!btn.closest(
        'cc-cart-cross-sell, [data-reco-promo-zone], .cart-item-upsells'
      );
      const formData = {
        items: [{
          id: parseInt(variantId, 10),
          quantity: 1
        }]
      };

      // Ajouter les sections a mettre a jour
      const sectionsToUpdate = document.querySelectorAll('[data-section-id]');
      if (sectionsToUpdate.length) {
        formData.sections = Array.from(sectionsToUpdate).map(function(el) {
          return el.dataset.sectionId;
        });
        formData.sections_url = window.location.pathname;
      }

      const response = await fetch(theme.routes.cartAdd, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.description || data.message || 'Erreur');
      }

      // Si l'ajout vient du cart drawer reco : applique le code promo.
      // IMPORTANT: redirect 'follow' (défaut) — avec 'manual' le navigateur reçoit
      // une réponse opaqueredirect et N'APPLIQUE PAS le Set-Cookie → pas de remise.
      // On cible ?redirect=/cart.js (payload minimal) pour poser le cookie discount.
      var discountApplied = false;
      if (isFromCartDrawerReco && window.themeRecoDrawerDiscountCode) {
        try {
          await fetch('/discount/' + encodeURIComponent(window.themeRecoDrawerDiscountCode) + '?redirect=/cart.js', {
            method: 'GET',
            credentials: 'same-origin'
          });
          discountApplied = true;
        } catch (e) { /* silencieux */ }
      }

      // Succes
      btn.classList.remove('quick-add-sizes__btn--loading');
      btn.classList.add('quick-add-sizes__btn--added');
      btn.disabled = false;

      // Mettre a jour les sections (panier header, drawer, etc.)
      // Si un discount vient d'être appliqué, on re-fetch les sections FRAÎCHES
      // (Section Rendering API) pour refléter le total remisé dans le drawer.
      if (discountApplied && sectionsToUpdate.length) {
        try {
          var ids = Array.from(sectionsToUpdate).map(function(el) { return el.dataset.sectionId; });
          var secRes = await fetch('/?sections=' + encodeURIComponent(ids.join(',')), {
            credentials: 'same-origin'
          });
          var freshSections = await secRes.json();
          sectionsToUpdate.forEach(function(el) {
            if (el.updateFromCartChange && freshSections[el.dataset.sectionId]) {
              el.updateFromCartChange(freshSections[el.dataset.sectionId]);
            }
          });
        } catch (e) {
          // fallback : sections issues du /cart/add.js (sans remise mais panier à jour)
          if (data.sections) {
            sectionsToUpdate.forEach(function(el) {
              if (el.updateFromCartChange && data.sections[el.dataset.sectionId]) {
                el.updateFromCartChange(data.sections[el.dataset.sectionId]);
              }
            });
          }
        }
      } else if (data.sections) {
        sectionsToUpdate.forEach(function(el) {
          if (el.updateFromCartChange && data.sections[el.dataset.sectionId]) {
            el.updateFromCartChange(data.sections[el.dataset.sectionId]);
          }
        });
      }

      // Gestion selon les settings du theme
      if (typeof theme !== 'undefined' && theme.settings) {
        if (theme.settings.afterAddToCart === 'page') {
          setTimeout(function() {
            window.location.href = theme.routes.cart;
          }, 300);
        } else if (theme.settings.afterAddToCart === 'drawer') {
          var cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.open === 'function') {
            cartDrawer.open();
          }
        }
      }

      // Retirer l'etat de succes apres un delai
      setTimeout(function() {
        btn.classList.remove('quick-add-sizes__btn--added');
        // Fermer le panel sur mobile apres ajout
        if (window.innerWidth < 768 && container) {
          container.classList.remove('is-expanded');
          var trigger = container.querySelector('.quick-add-sizes__trigger');
          if (trigger) trigger.setAttribute('aria-expanded', 'false');
        }
      }, 1500);

    } catch (error) {
      console.error('Quick Add Error:', error);
      btn.classList.remove('quick-add-sizes__btn--loading');
      btn.classList.add('quick-add-sizes__btn--error');
      btn.disabled = false;

      setTimeout(function() {
        btn.classList.remove('quick-add-sizes__btn--error');
      }, 2000);
    }
  });

})();
